// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_79t","cls2":"FilterPanel-cls2_LAC FilterPanel-cls1_79t"};